import moment from "moment"
import { FC, useEffect, useState } from "react"

import styles from "./XHeader.module.scss"
import {prevent} from "../../utils"
import {useWindowDimensions} from "../../hooks"

export type XHeaderProps = {
  children: any
}

export type XHeaderExtensions = {
  Col: typeof Col
  Dropdown: typeof Dropdown
}

export type XHeaderColProps = {
  children?: any
}

export type XHeaderDropdownProps = {
  menu: any[]
  visible: boolean
  align?: string
  children?: any
  closable?: boolean
  dpAccShown?: boolean
  onMenuClick?: (item: any) => void
  setDpAccShown?: (val: boolean) => void
  onClose?: () => void
}

export const XHeader: FC<XHeaderProps> & XHeaderExtensions = ({
  children
}) => {

  const { width } = useWindowDimensions()
  
  const [accountDropdOpenned, setAccountDropdOpenned] = useState(false)
  const [timeDropdOpenned, setTimeDropdOpenned] = useState(false)
  
  const [timing, setTiming] = useState("")

  useEffect(() => {
    const now = moment()
    setTiming(prev => prev = now.format("HH") + "<span>:</span>" + now.format("mm"))
    
    setInterval(() => {
      const now = moment()
      setTiming(prev => prev = now.format("HH") + "<span>:</span>" + now.format("mm"))
    }, 5000)
  }, [])

  return (
    <>
      <div className={styles.adminx_header}>
        {children}
      </div>
    </>
  )
}

const Col: FC<XHeaderColProps> = ({
  children
}) => {
  return (
    <>
      <div className={styles.adminx_header__col + " " + styles.xflex}>{children}</div>
    </>
  )
}

const Dropdown: FC<XHeaderDropdownProps> = ({
  children, menu, onMenuClick, onClose, closable = true, align = "center", dpAccShown, setDpAccShown
}) => {
  
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const [dropdownShown, setDropdownShown] = useState(false)

  const onKeydown = ({ key }: KeyboardEvent) => {
    switch (key) {
      case 'Escape':
        if (closable) {
          setDropdownVisible(false)
          setTimeout(() => {
            if (onClose != undefined) {
              onClose()
            }
            document.removeEventListener('mouseup', onMouseUp)
            setDropdownShown(false)
          }, 300);
        }
        break;
    }
  }

  const onMouseUp = (e: any) => {
    var container = document.getElementById("ddp_menu")

    console.log("PRE-FIRREEEE", e)
    if (container != null && !container.contains(e.target) && dpAccShown) {
      //container.style.display = 'none'
      console.log("FIRREEEE!!!", e)
      onCloseRef()
    }
  }

  const onCloseRef = () => {
    setDropdownVisible(prev => prev = false)
    setTimeout(() => {
      if (onClose != undefined) {
        onClose()
      }
      document.removeEventListener('mouseup', onMouseUp)
      setDropdownShown(prev => prev = false)
    }, 300)
  }

  useEffect(() => {
    setDpAccShown!(dropdownVisible)
  }, [dropdownVisible])

  useEffect(() => {
    document.addEventListener('keydown', onKeydown)

    return () => {
      document.removeEventListener('keydown', onKeydown)
    }
  }, [])

  return (
    <>
      <div className={styles.dropdown}>
        <div className={styles.dropdown_item} onClick={() => {
          if (!dropdownShown) {
            setDropdownShown(prev => prev = true)
            setTimeout(() => {
              setDropdownVisible(prev => prev = true)
              setTimeout(() => {
                document.addEventListener('mouseup', onMouseUp)
              }, 500)
            }, 100)
          } else {
            setDropdownVisible(prev => prev = false)
            setTimeout(() => {
              setDropdownShown(prev => prev = false)
              setTimeout(() => {
                document.removeEventListener('mouseup', onMouseUp)
              }, 500)
            }, 300)
          }
        }}>
          {children}
        </div>
        <div style={{
          display: dropdownShown ? "block" : "none"
        }} className={styles.dropdown_modal + (dropdownVisible ? " " + styles.openned : "") + (align == "right" ? " " + styles.right : "")}>
          <div className={styles.dd_m__wrap + " " + styles[`wrap_${align}`]} id="ddp_menu">
            <div className={styles.dd_m__body}>
              <div className={styles.dd_m__body__menu}>
                {menu.map(item => <a href={item.url} onClick={(ev) => {
                  prevent(ev)
                  return onMenuClick!(item)
                }}><span><i className={item.icon}></i> {item.label}</span></a>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

XHeader.Col = Col
XHeader.Dropdown = Dropdown